<template>
    <div class="wrapper ">
       Front Office
    </div>
</template>

<script>
  export default {
    name: "FrontOffice"
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/FrontOffice.vue